import * as React from "react";
import { navigate } from "@reach/router";
import { ReactComponent as CloseSVG } from "../../icons/close.svg";
import type { Theme } from "src/theme";
type Props = {
  children: React.ReactNode;
  onClose?: () => void;
};

const overlayBackdropStyle = ({ gridUnit }: Theme) => ({
  position: "fixed" as const,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  zIndex: 1000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: gridUnit * 5
});

const overlayContentStyle = {
  position: "relative" as const,
  background: "white",
  borderRadius: "8px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
  maxWidth: "90vw",
  maxHeight: "90vh",
  overflow: "auto" as const
};

const closeButtonStyle = {
  position: "absolute" as const,
  top: "10px",
  right: "10px",
  background: "white",
  border: "2px solid #333",
  borderRadius: "50%",
  width: "36px",
  height: "36px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  transition: "all 0.2s ease",
  zIndex: 10,
  ":hover": {
    backgroundColor: "#f5f5f5",
    transform: "scale(1.1)"
  },
  svg: {
    width: "20px",
    height: "20px",
    stroke: "#333"
  }
};

const OverlayPanel = ({ children, onClose }: Props): React.ReactNode => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate("/game");
    }
  };

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target;
    if (target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div css={overlayBackdropStyle} onClick={handleBackdropClick}>
      <div css={overlayContentStyle}>
        <button css={closeButtonStyle} onClick={handleClose} aria-label="Close" type="button">
          <CloseSVG />
        </button>
        {children}
      </div>
    </div>
  );
};

export default OverlayPanel;
